import React, { Component } from "react";
import { FormControl, Button, FormGroup, Row, ControlLabel, Col, Radio, Table, Form, Image, ButtonToolbar } from "react-bootstrap";
import { PropTypes } from "prop-types";
import { LoadingSpinner } from "../LoadingSpinner";
import { AuxImagesAPI } from "../../api/files/AuxImagesAPI";
import { BusMapSettingsAPI } from "../../api/busmap/BusMapSettingsAPI";
import { TitleRow } from "../TitleRow";
import { HandleDialog } from "../HandleDialog";
import { HandleMessage } from "../HandleMessage";
import { ColorDisplayer } from "../ColorDisplayer";
import { TableButton } from '../TableButton';
import { strings } from "./strings";
import { SketchPicker } from 'react-color';
import Select from "react-select";

const defaultPageSizes = [
    {
        label: "A3",
        dimensions: {
            width: 297,
            height: 420
        }
    },
    {
        label: "A4",
        dimensions: {
            width: 210,
            height: 297
        }
    },
    {
        label: "A5",
        dimensions: {
            width: 148,
            height: 210
        }
    }
];

const optionsWithFont = {
    option: (styles, { data }) => ({ ...styles, fontFamily: data.value }),
    singleValue: (styles, { data }) => ({ ...styles, fontFamily: data.value })
};

export class BusMapSettings extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            errorModal: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            interfaces: {
                printInterfaces: undefined,
                printInterfacesLabel: undefined
            },
            labels: {
                printTitle: undefined,
                printProviderLogo: undefined
            },
            settingsId: 0,
            pageDimensions: {
                width: 210,
                height: 297,
                marginTop: 10,
                marginRight: 7,
                marginBottom: 10,
                marginLeft: 7,
                headerHeight: 27,
                footerHeight: 41,
                routeHeaderHeight: 28
            },
            fontsAndColors: {
                stopLabelFont: "Arial",
                stopLabelColor: "#505050",
                stopLabelTextColor: "#ffffff",
                mapPointLabelFont: "Arial",
                mapPointLabelColor: "#5A5A5A",
                mapPointLabelTextColor: "#ffffff",
                lineNumberFont: "Arial",
                arrowColor: "#fcb814"
            },
            selectedImages: {
                header: undefined,
                footer: undefined
            },
            availableFonts: [],
            showColorPicker: false,
            currentColor: "",
            colorToChange: ""
        };
    }

    componentDidMount() {
        this.context.selectApp("busmap", false);

        this.loadAuxImages();
        this.loadBusMapSettings();
        this.loadFonts();
    }

    // --------------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    setErrorMessage(error) {
        this.setState({
            dialog: {
                show: true
            },
            errorModal: {
                show: true,
                title: strings.error,
                message: error.message,
                style: 'danger',
                icon: 'remove'
            },
            loading: false
        });
    }

    processBusMapSettingsData(data) {
        if (data.id === 0) {
            this.setState({
                settingsId: 0,
                loading: false
            });
            return;
        }

        this.setState({
            loading: false,
            settingsId: data.id,
            pageDimensions: {
                width: data.width,
                height: data.height,
                marginTop: data.marginTop,
                marginRight: data.marginRight,
                marginBottom: data.marginBottom,
                marginLeft: data.marginLeft,
                headerHeight: data.headerHeight,
                footerHeight: data.footerHeight,
                routeHeaderHeight: data.routeHeaderHeight
            },
            fontsAndColors: {
                stopLabelFont: data.stopLabelFont,
                stopLabelColor: data.stopLabelColor,
                stopLabelTextColor: data.stopLabelTextColor,
                mapPointLabelFont: data.mapPointLabelFont,
                mapPointLabelColor: data.mapPointLabelColor,
                mapPointLabelTextColor: data.mapPointLabelTextColor,
                lineNumberFont: data.lineNumberFont,
                arrowColor: data.arrowColor
            },
            interfaces: {
                printInterfaces: data.printInterfaces,
                printInterfacesLabel: data.printInterfacesLabel
            },
            labels: {
                printTitle: data.printTitle,
                printProviderLogo: data.printProviderLogo
            },
            selectedImages: {
                header: data.headerId,
                footer: data.footerId
            },
        });
    }

    processFontsData(data) {
        this.setState({
            availableFonts: data.filter(function (f) {
                return f.name !== "";
            }).map(function (f) {
                return { value: f.name, label: f.name }
            }),
            loading: false
        });
    }

    processAuxImagesData(data) {
        const headers = data.filter(image => image.type === "H");
        const footers = data.filter(image => image.type === "F");

        this.setState({
            loading: false,
            headers: headers,
            footers: footers
        });
    }

    /* #region Upload de header e footer */
    loadBusMapSettings() {
        if (this.isTransportAuthorityData()) {
            BusMapSettingsAPI.getTransportAuthority()
                .then(response => JSON.parse(response))
                .then(data => this.processBusMapSettingsData(data))
                .catch(error => this.setErrorMessage(error));
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            BusMapSettingsAPI.get(selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processBusMapSettingsData(data))
                .catch(error => this.setErrorMessage(error));
        }
    }

    loadFonts() {
        if (this.isTransportAuthorityData()) {
            BusMapSettingsAPI.getTransportAuthorityFonts()
                .then(response => JSON.parse(response))
                .then(data => this.processFontsData(data))
                .catch(error => this.setErrorMessage(error));
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            BusMapSettingsAPI.getFonts(selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processFontsData(data))
                .catch(error => this.setErrorMessage(error));
        }
    }

    loadAuxImages() {
        if (this.isTransportAuthorityData()) {
            AuxImagesAPI.listTransportAuthority()
                .then(response => JSON.parse(response))
                .then(data => this.processAuxImagesData(data))
                .catch(error => this.setErrorMessage(error));
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            AuxImagesAPI.list(selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processAuxImagesData(data))
                .catch(error => this.setErrorMessage(error));
        }
    }

    uploadImage = event => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const apiResult = this.isTransportAuthorityData() ? AuxImagesAPI.createTransportAuthority(formData) : AuxImagesAPI.create(formData);

        this.setState({
            loading: true
        },
            () => apiResult.then(response => JSON.parse(response))
                .then(_ => this.setState({ loading: true }, () => this.loadAuxImages()))
        );
    };

    handleChangeImageClick = image => {
        if (image.type === "H") {
            image.type = "F";
        } else if (image.type === "F") {
            image.type = "H";
        }

        const apiResult = this.isTransportAuthorityData() ? AuxImagesAPI.updateTransportAuthority(image.id, image) : AuxImagesAPI.update(image.id, image);

        this.setState({
            loading: true
        },
            () => apiResult.then(response => JSON.parse(response))
                .then(_ => this.setState({ loading: true }, () => this.loadAuxImages()))
        );
    };

    handleDeleteImageClick = image => {
        var { selectedImages } = this.state;
        var confirmed = false;

        if (selectedImages.header !== image.id || selectedImages.footer !== image.id) {
            confirmed = true;
        }

        if (!confirmed) {
            this.setState({
                errorModal: {
                    show: true,
                    title: strings.warning,
                    message: strings.cantDeleteSelectedImage,
                    style: "danger",
                    icon: "alert"
                }
            });
            return;
        }

        if (confirmed) {
            const apiResult = this.isTransportAuthorityData() ? AuxImagesAPI.deleteTransportAuthority(image.id) : AuxImagesAPI.delete(image.id);

            this.setState({
                    loading: true
                },
                () => apiResult.then(response => JSON.parse(response))
                        .then(_ => this.setState({
                                errorModal: {
                                    show: true,
                                    title: strings.success,
                                    message: strings.removedImage,
                                    style: "success",
                                    icon: "ok"
                                }
                            }, () => this.loadAuxImages()))
                        .catch(error => this.setErrorMessage(error))
            );
            return;
        }

        return;
    };

    toggleImageSelection = (id, type) => {
        var { selectedImages } = this.state;

        if (selectedImages[type] === id) {
            selectedImages[type] = undefined;
        } else {
            selectedImages[type] = id;
        }

        this.setState({ selectedImages }/*, this.saveSettings*/);
    };

    validateSettings = () => {
        // var { selectedImages } = this.state;

        var confirmed = false;

        // Valida que está selecionado um header e um footer
        //if (
        //  typeof selectedImages.header !== "undefined" &&
        //  typeof selectedImages.footer !== "undefined"
        //) {
        //  confirmed = true;
        //}

        confirmed = true;

        if (!confirmed) {
            this.setState({
                errorModal: {
                    show: true,
                    title: strings.warning,
                    message: strings.mustSelectHeaderandFooter,
                    style: "danger",
                    icon: "alert"
                }
            });
            return;
        }

        if (confirmed) {
            this.saveSettings();
        }
        return;
    };

    saveSettings = () => {
        var { settingsId, pageDimensions, fontsAndColors, interfaces, labels, selectedImages } = this.state;

        var settings = {
            width: pageDimensions.width,
            height: pageDimensions.height,
            marginTop: pageDimensions.marginTop,
            marginRight: pageDimensions.marginRight,
            marginBottom: pageDimensions.marginBottom,
            marginLeft: pageDimensions.marginLeft,
            headerHeight: pageDimensions.headerHeight,
            footerHeight: pageDimensions.footerHeight,
            routeHeaderHeight: pageDimensions.routeHeaderHeight,
            stopLabelFont: fontsAndColors.stopLabelFont,
            stopLabelColor: fontsAndColors.stopLabelColor,
            stopLabelTextColor: fontsAndColors.stopLabelTextColor,
            mapPointLabelFont: fontsAndColors.mapPointLabelFont,
            mapPointLabelColor: fontsAndColors.mapPointLabelColor,
            mapPointLabelTextColor: fontsAndColors.mapPointLabelTextColor,
            lineNumberFont: fontsAndColors.lineNumberFont,
            arrowColor: fontsAndColors.arrowColor,
            printInterfaces: interfaces.printInterfaces,
            printInterfacesLabel: interfaces.printInterfacesLabel,
            printTitle: labels.printTitle,
            printProviderLogo: labels.printProviderLogo,
            headerId: selectedImages.header,
            footerId: selectedImages.footer
        };

        this.setState({
            loading: true
        },
            function () {
                const isTransportAuthorityData = this.isTransportAuthorityData();

                var method;
                if (settingsId === 0) {
                    method = isTransportAuthorityData ? BusMapSettingsAPI.createTransportAuthority(settings) : BusMapSettingsAPI.create(settings);
                } else {
                    settings.id = settingsId;
                    method = isTransportAuthorityData ? BusMapSettingsAPI.updateTransportAuthority(settingsId, settings) : BusMapSettingsAPI.update(settingsId, settings);
                }
                method.then(response => JSON.parse(response))
                    .then(data => {
                        this.setState({
                            settingsId: data.id,
                            errorModal: {
                                show: true,
                                title: strings.success,
                                message: strings.settingsUpdated,
                                style: "success",
                                icon: "ok"
                            },
                            loading: false
                        });
                    })
                    .catch(error => this.setErrorMessage(error));
            }
        );
    };

    /* #endregion Upload de header e footer */

    changePageDimension = event => {
        var { pageDimensions } = this.state;
        var selectedPageSize = defaultPageSizes.filter(
            e => e.label === event.target.value
        )[0];

        if (typeof selectedPageSize === "undefined") {
            return;
        }

        pageDimensions.width = selectedPageSize.dimensions.width;
        pageDimensions.height = selectedPageSize.dimensions.height;

        this.setState({
            pageDimensions
        });
    };

    storeValue = (param, value) => {
        var { pageDimensions, fontsAndColors, interfaces, labels } = this.state;

        if (param in pageDimensions) {
            pageDimensions[param] = value;
        } else if (param in fontsAndColors) {
            fontsAndColors[param] = value;
        } else if (param in interfaces) {
            interfaces[param] = value;
        }else if (param in labels) {
            labels[param] = value;
        }

        this.setState({
            pageDimensions,
            fontsAndColors,
            interfaces,
            labels
        });
    };

    clearError = () => {
        this.setState({
            showColorPicker: false,
            errorModal: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    };

    showColorPicker = (currentColor, colorToChange) => {
        this.setState({
            showColorPicker: true,
            currentColor: currentColor,
            colorToChange: colorToChange
        })
    }

    headerFooterImages() {
        var { headers, footers, selectedImages } = this.state;

        return (
            <Row>
                <Col sm={12}>
                    <TitleRow
                        title={strings.headerFooterImages}
                        showSeparator={false}
                        showBackground={true}
                        element="h2"
                    />
                    <Form horizontal onSubmit={this.uploadImage}>
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.uploadNew}
                            </Col>
                            <Col sm={12} md={3}>
                                <FormControl
                                    name="File"
                                    type="file"
                                    label={strings.upload}
                                    accept=".png,.bmp,.svg,.jpg,.gif"
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.type}
                            </Col>
                            <Col sm={12} md={3}>
                                <Radio key={1} name="Type" value="H" inline defaultChecked>
                                    {strings.header}
                                </Radio>{" "}
                                <Radio key={2} name="Type" value="F" inline>
                                    {strings.footer}
                                </Radio>
                            </Col>
                            <Col sm={12} md={2}>
                                <Button type="submit">{strings.uploadButton}</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
                <Col sm={12} md={6}>
                    <TitleRow title={strings.header} showSeparator={false} element="h3" />
                    {typeof headers !== "undefined" && headers.length !== 0 ? (
                        <Table responsive striped hover>
                            <tbody>
                                {headers.map((image, Index) => (
                                    <tr
                                        key={Index}
                                        onClick={() =>
                                            this.toggleImageSelection(image.id, "header")
                                        }
                                        className={
                                            selectedImages.header === image.id
                                                ? "bus-map-stop-selected"
                                                : null
                                        }
                                    >
                                        <td>
                                            <Image
                                                src={image.url}
                                                thumbnail
                                                style={{ maxWidth: 100, maxHeight: 100 }}
                                            />
                                        </td>
                                        <td>
                                            <ButtonToolbar>
                                                <TableButton marginRight icon="icon-network" title="Definir como Rodapé" onClick={() => this.handleChangeImageClick(image)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteImageClick(image)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                            <p className="text-center">{strings.noHeaderImages}</p>
                        )}
                </Col>
                <Col sm={12} md={6}>
                    <TitleRow title={strings.footer} showSeparator={false} element="h3" />
                    {typeof footers !== "undefined" && footers.length !== 0 ? (
                        <Table responsive striped hover>
                            <tbody>
                                {footers.map((image, Index) => (
                                    <tr
                                        key={Index}
                                        onClick={() =>
                                            this.toggleImageSelection(image.id, "footer")
                                        }
                                        className={
                                            selectedImages.footer === image.id
                                                ? "bus-map-stop-selected"
                                                : null
                                        }
                                    >
                                        <td>
                                            <Image
                                                src={image.url}
                                                thumbnail
                                                style={{ maxWidth: 100, maxHeight: 100 }}
                                            />
                                        </td>
                                        <td>
                                            <ButtonToolbar>
                                                <TableButton marginRight icon="icon-network" title="Definir como Cabeçalho" onClick={() => this.handleChangeImageClick(image)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteImageClick(image)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                            <p className="text-center">{strings.noFooterImages}</p>
                        )}
                </Col>
            </Row>
        );
    }

    pageDimensionsSettings() {
        var { pageDimensions } = this.state;

        return (
            <Row>
                <Col sm={12}>
                    <TitleRow
                        title={strings.pageDimensions}
                        showSeparator={false}
                        showBackground={true}
                        element="h2"
                    />
                </Col>
                <Col sm={12}>
                    <Form horizontal>
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageSizes}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    componentClass="select"
                                    placeholder="select"
                                    onChange={this.changePageDimension}
                                >
                                    <option key="a" value={null}>
                                        -
                  </option>
                                    {defaultPageSizes.map((value, index) => (
                                        <option value={value.label} key={index}>
                                            {value.label}
                                        </option>
                                    ))}
                                </FormControl>
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageWidth}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    id="pageWidth"
                                    type="text"
                                    value={pageDimensions.width}
                                    onChange={e => this.storeValue("width", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageHeight}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    id="pageHeight"
                                    type="text"
                                    value={pageDimensions.height}
                                    onChange={e => this.storeValue("height", e.target.value)}
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                    <hr />
                    <Form horizontal>
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageHeaderHeight}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    id="pageHeaderHeight"
                                    type="text"
                                    value={pageDimensions.headerHeight}
                                    onChange={e => this.storeValue("headerHeight", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageFooterHeight}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    id="pageFooterHeight"
                                    type="text"
                                    value={pageDimensions.footerHeight}
                                    onChange={e => this.storeValue("footerHeight", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageRouteHeaderHeight}
                            </Col>
                            <Col sm={12} md={2}>
                                <FormControl
                                    id="pageRouteHeaderHeight"
                                    type="text"
                                    value={pageDimensions.routeHeaderHeight}
                                    onChange={e => this.storeValue("routeHeaderHeight", e.target.value)}
                                />
                            </Col>
                        </FormGroup>
                    </Form>

                    <TitleRow
                        title={strings.pageMargins}
                        showSeparator={false}
                        element="h3"
                    />
                    <Form horizontal>
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageMarginTop}
                            </Col>
                            <Col sm={12} md={1}>
                                <FormControl
                                    id="pageMarginTop"
                                    type="text"
                                    value={pageDimensions.marginTop}
                                    onChange={e => this.storeValue("marginTop", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageMarginRight}
                            </Col>
                            <Col sm={12} md={1}>
                                <FormControl
                                    id="pageMarginRight"
                                    type="text"
                                    value={pageDimensions.marginRight}
                                    onChange={e => this.storeValue("marginRight", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageMarginBottom}
                            </Col>
                            <Col sm={12} md={1}>
                                <FormControl
                                    id="pageMarginBottom"
                                    type="text"
                                    value={pageDimensions.marginBottom}
                                    onChange={e => this.storeValue("marginBottom", e.target.value)}
                                />
                            </Col>
                            <Col componentClass={ControlLabel} sm={12} md={2}>
                                {strings.pageMarginLeft}
                            </Col>
                            <Col sm={12} md={1}>
                                <FormControl
                                    id="pageMarginLeft"
                                    type="text"
                                    value={pageDimensions.marginLeft}
                                    onChange={e => this.storeValue("marginLeft", e.target.value)}
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
        );
    }

    interfaceSettings() {
        var { interfaces } = this.state;

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <TitleRow
                            title={strings.interfaceSettings}
                            showSeparator={false}
                            showBackground={true}
                            element="h2"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Form horizontal>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.printInterfaces}
                                </Col>
                                <Col sm={12} md={3}>
                                    <FormGroup>
                                        <Radio key={1} name="PrintInterfaces" value="true" inline checked={interfaces.printInterfaces ? "checked" : ""} onChange={e => this.storeValue("printInterfaces", true)}>
                                            {strings.yes}
                                        </Radio>{" "}
                                        <Radio key={2} name="PrintInterfaces" value="false" inline checked={!interfaces.printInterfaces ? "checked" : ""} onChange={e => this.storeValue("printInterfaces", false)}>
                                            {strings.no}
                                        </Radio>
                                    </FormGroup>
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.printInterfacesLabel}
                                </Col>
                                <Col sm={12} md={3}>
                                    <Radio key={1} name="PrintInterfacesLabel" value="true" inline checked={interfaces.printInterfacesLabel ? "checked" : ""} onChange={e => this.storeValue("printInterfacesLabel", true)}>
                                        {strings.yes}
                                    </Radio>{" "}
                                    <Radio key={2} name="PrintInterfacesLabel" value="false" inline checked={!interfaces.printInterfacesLabel ? "checked" : ""} onChange={e => this.storeValue("printInterfacesLabel", false)}>
                                        {strings.no}
                                    </Radio>
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }

    labelsSettings() {
        var { labels } = this.state;

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <TitleRow
                            title={strings.labelsSettings}
                            showSeparator={false}
                            showBackground={true}
                            element="h2"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Form horizontal>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.printTitle}
                                </Col>
                                <Col sm={12} md={3}>
                                    <FormGroup>
                                        <Radio key={1} name="PrintTitle" value="true" inline checked={labels.printTitle ? "checked" : ""} onChange={e => this.storeValue("printTitle", true)}>
                                            {strings.yes}
                                        </Radio>{" "}
                                        <Radio key={2} name="PrintTitle" value="false" inline checked={!labels.printTitle ? "checked" : ""} onChange={e => this.storeValue("printTitle", false)}>
                                            {strings.no}
                                        </Radio>
                                    </FormGroup>
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.printProviderLogo}
                                </Col>
                                <Col sm={12} md={3}>
                                    <Radio key={1} name="PrintProviderLogo" value="true" inline checked={labels.printProviderLogo ? "checked" : ""} onChange={e => this.storeValue("printProviderLogo", true)}>
                                        {strings.yes}
                                    </Radio>{" "}
                                    <Radio key={2} name="PrintProviderLogo" value="false" inline checked={!labels.printProviderLogo ? "checked" : ""} onChange={e => this.storeValue("printProviderLogo", false)}>
                                        {strings.no}
                                    </Radio>
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }

    fontsAndColorsSettings() {
        var { fontsAndColors, availableFonts } = this.state;

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <TitleRow
                            title={strings.fontsAndColors}
                            showSeparator={false}
                            showBackground={true}
                            element="h2"
                        />
                    </Col>
                    <TitleRow
                        title={strings.stopLabel}
                        showSeparator={false}
                        element="h3"
                    />
                    <Col sm={12}>
                        <Form horizontal>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.stopLabelFont}
                                </Col>
                                <Col sm={12} md={2}>
                                    <Select
                                        onChange={f => this.storeValue("stopLabelFont", f.value)}
                                        options={availableFonts}
                                        value={availableFonts.filter((f) => f.value === fontsAndColors.stopLabelFont)[0]}
                                        isSearchable={true}
                                        styles={optionsWithFont}
                                    />
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.stopLabelTextColor}
                                </Col>
                                <Col sm={12} md={2}>
                                    <ColorDisplayer color={fontsAndColors.stopLabelTextColor} cursor="pointer" onClick={e => this.showColorPicker(e.target.value, "stopLabelTextColor")} />
                                    {this.getColorPickerFor(fontsAndColors.stopLabelTextColor, "stopLabelTextColor")}
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.stopLabelColor}
                                </Col>
                                <Col sm={12} md={2}>
                                    <ColorDisplayer color={fontsAndColors.stopLabelColor} cursor="pointer" onClick={e => this.showColorPicker(e.target.value, "stopLabelColor")} />
                                    {this.getColorPickerFor(fontsAndColors.stopLabelColor, "stopLabelColor")}
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.lineNumberFont}
                                </Col>
                                <Col sm={12} md={2}>
                                    <Select
                                        onChange={f => this.storeValue("lineNumberFont", f.value)}
                                        options={availableFonts}
                                        value={availableFonts.filter((f) => f.value === fontsAndColors.lineNumberFont)[0]}
                                        isSearchable={true}
                                        styles={optionsWithFont}
                                    />
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.arrowColor}
                                </Col>
                                <Col sm={12} md={2}>
                                    <ColorDisplayer color={fontsAndColors.arrowColor} cursor="pointer" onClick={e => this.showColorPicker(e.target.value, "arrowColor")} />
                                    {this.getColorPickerFor(fontsAndColors.arrowColor, "arrowColor")}
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                    <TitleRow
                        title={strings.mapPointLabel}
                        showSeparator={false}
                        element="h3"
                    />
                    <Col sm={12}>
                        <Form horizontal>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.mapPointLabelFont}
                                </Col>
                                <Col sm={12} md={2}>
                                    <Select
                                        onChange={f => this.storeValue("mapPointLabelFont", f.value)}
                                        options={availableFonts}
                                        value={availableFonts.filter((f) => f.value === fontsAndColors.mapPointLabelFont)[0]}
                                        isSearchable={true}
                                        styles={optionsWithFont}
                                    />
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.mapPointLabelTextColor}
                                </Col>
                                <Col sm={12} md={2}>
                                    <ColorDisplayer color={fontsAndColors.mapPointLabelTextColor} cursor="pointer" onClick={e => this.showColorPicker(e.target.value, "mapPointLabelTextColor")} />
                                    {this.getColorPickerFor(fontsAndColors.mapPointLabelTextColor, "mapPointLabelTextColor")}
                                </Col>
                                <Col componentClass={ControlLabel} sm={12} md={2}>
                                    {strings.mapPointLabelColor}
                                </Col>
                                <Col sm={12} md={2}>
                                    <ColorDisplayer color={fontsAndColors.mapPointLabelColor} cursor="pointer" onClick={e => this.showColorPicker(e.target.value, "mapPointLabelColor")} />
                                    {this.getColorPickerFor(fontsAndColors.mapPointLabelColor, "mapPointLabelColor")}
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col sm={12}>
                        <Form horizontal></Form>
                    </Col>
                </Row>
            </div>
        );
    }

    getColorPickerFor = (currentColor, name) => {
        var { showColorPicker, colorToChange } = this.state;

        return (showColorPicker && colorToChange === name ?
            <div style={{ position: 'absolute', zIndex: 2 }}>
                <div style={{ position: "fixed", top: "0px", right: "0px", bottom: "0px", left: "0px" }} onClick={this.clearError} />
                <SketchPicker color={currentColor} onChange={color => this.storeValue(colorToChange, color.hex)} />
            </div> : null);
    }

    render() {
        var { loading, errorModal, dialog } = this.state;
        let contents;

        if (loading) {
            return <LoadingSpinner />;
        }

        contents = (
            <div>
                <TitleRow title={strings.settings} showSeparator={true}>
                    <Button
                        onClick={() => this.validateSettings()}
                        className="pull-right"
                    >
                        {strings.save}
                    </Button>
                </TitleRow>
                {this.pageDimensionsSettings()}
                {this.headerFooterImages()}
                {this.interfaceSettings()}
                {this.labelsSettings()}
                {this.fontsAndColorsSettings()}
            </div>
        );

        return (
            <div className="container-fluid busmap">
                {contents}
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExit(a, b)}
                />
                <HandleMessage
                    show={errorModal.show}
                    title={errorModal.title}
                    message={errorModal.message}
                    style={errorModal.style}
                    icon={errorModal.icon}
                    onHide={this.clearError}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/busmap/BusMapSettings.js